// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    api: 'http://192.168.88.231:54732/',
    widgetsHost: 'https://wg.ud4.ru',
    vkAppIds: {
        payment: 7486357,
        rooms: 6445829,
        schedule: 6277910,
        subscriptions: 6445819,
        courses: 6486550,
        coaches: 6486553
    },
};
